import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

export const list = css`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(${spacing.sm});
`;

export const listItem = css`
  display: flex;
  align-items: center;
  gap: var(${spacing.xs});
`;

export const iconBadge = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: var(${borderRadius.full.mobile});
  background-color: var(${colors.surface.brand});
  color: var(${colors.content.interactive});
`;

export const text = css`
  color: var(${colors.content.primary});
  font-size: var(${typography.body.sizes.md.fontSize});
  line-height: var(${typography.body.sizes.md.lineHeight});
`;

export const linkText = css`
  ${text};
  color: var(${colors.content.link});
`;
